export function opusCodecHeaderB64(sampleRate: number, framesPerPacket: number, frameSizeMs: number) {
  const b0 = sampleRate & 0xff
  const b1 = (sampleRate >> 8) & 0xff
  const bytes = [b0, b1, framesPerPacket & 0xff, frameSizeMs & 0xff]
  return btoa(String.fromCharCode(...bytes))
}

export function buildZelloAudioPacket(streamId: number, opusPayload: Uint8Array) {
  const buf = new ArrayBuffer(9 + opusPayload.length)
  const dv = new DataView(buf)
  dv.setUint8(0, 0x01)
  dv.setUint32(1, streamId, false)
  dv.setUint32(5, 0, false)
  new Uint8Array(buf, 9).set(opusPayload)
  return buf
}